import Button from "@bmi-digital/components/button";
import Dialog from "@bmi-digital/components/dialog";
import ArrowForwardIcon from "@bmi-digital/components/icon/ArrowForward";
import ErrorOutlineOutlined from "@bmi-digital/components/icon/ErrorOutlineOutlined";
import { graphql } from "gatsby";
import React from "react";
import { Head } from "../../components/Head";
import RichText from "../../components/RichText";
import { getPathWithCountryCode } from "../../utils/path";
import { useConfig } from "../../contexts/ConfigProvider";
import {
  StyledIEDialog,
  StyledIEDialogWrapper,
  classes
} from "./styles/ie-dialog.styles";
import type { RichTextData } from "../../components/RichText";
import type {
  PayloadInternetExplorerDialog,
  PayloadSite
} from "../../types/payload";

type InternetExplorerDialog = Pick<
  PayloadInternetExplorerDialog,
  "ieDialogTitle" | "ieDialogActionLabel" | "ieDialogActionLink"
> & {
  ieDialogBody: RichTextData | null;
};

export type Props = {
  data: {
    payloadInternetExplorerDialog: InternetExplorerDialog;
    payloadSite: Pick<PayloadSite, "countryCode">;
  };
};

const IEDialog = ({ data }: Props) => {
  const { marketLocaleCode } = useConfig();
  const ieDialogData = data.payloadInternetExplorerDialog;

  return (
    <>
      <Head
        title={ieDialogData.ieDialogTitle}
        seo={null}
        path={getPathWithCountryCode(data.payloadSite.countryCode, "ie-dialog")}
        htmlAttributes={{ lang: marketLocaleCode }}
        countryCode={data.payloadSite.countryCode}
      />
      <StyledIEDialogWrapper>
        <StyledIEDialog>
          <Dialog.Title hasUnderline className={classes["IEDialog-title"]}>
            <ErrorOutlineOutlined className={classes["IEDialog-icon"]} />
            {ieDialogData.ieDialogTitle}
          </Dialog.Title>
          <Dialog.Content className={classes["IEDialog-body"]}>
            <RichText document={ieDialogData.ieDialogBody} />
          </Dialog.Content>

          <div className={classes["IEDialog-actions"]}>
            <Button
              href={ieDialogData.ieDialogActionLink ?? undefined}
              external
              endIcon={<ArrowForwardIcon />}
              gtm={{
                id: "cta-click1",
                label: ieDialogData.ieDialogActionLabel,
                action: ieDialogData.ieDialogActionLink
              }}
            >
              {ieDialogData.ieDialogActionLabel}
            </Button>
          </div>
        </StyledIEDialog>
      </StyledIEDialogWrapper>
    </>
  );
};

export default IEDialog;

export const pageQuery = graphql`
  query GeneralIEDialog {
    payloadInternetExplorerDialog {
      ieDialogTitle
      ieDialogActionLabel
      ieDialogActionLink
      ieDialogBody {
        ...RichTextFragment
      }
    }
    payloadSite {
      countryCode
    }
  }
`;
